import classNames from "classnames"
import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import { DATE } from "helpers/shapes"
import CompareChart from "components/charts/compare"
import CompareTable from "components/compare-table"
import CompareSelect from "components/material/compare-select"
import { numberFormatter } from "helpers/formatters/numbers"
import { AGGREGATION_SHAPE } from "helpers/factorClassification"
import AggregationDropdown, { OPTION_SHAPE } from "components/list-item-dropdown"
import { FACTOR_CATEGORIES_SHAPE } from "components/factor-categories/shapes"
import { DATA, DOWNLOAD_FILENAME, METRICS, SELECTED_METRIC, TABLE_DOWNLOAD_DATA } from "helpers/shapes/compare-screen"
import "./styles.scss"

export default function CompareExposure({
  data,
  metrics,
  status,
  startDate,
  endDate,
  selectedDate,
  setDate,
  selectedMetric,
  items,
  detailsItems,
  detailsData,
  trackPanelTrigger,
  fixedItemNumber,
  hideGraph,
  displayAggregationToggle,
  setAggregationFn,
  aggregation,
  aggregationOptions,
  contentSetId,
  factorCategories,
  setMetric,
  saveMetricToStore,
  fileName,
  tableDownloadData,
}) {
  const selectedView = contentSetId || "exposure"
  return <Paper className="modules_compare-exposure" square elevation={1}>
    <div className="wrapper">
      {displayAggregationToggle && !contentSetId && <AggregationDropdown setValue={setAggregationFn} value={aggregation} listSubheader="Choose display type for style factors" label="Display Type" options={aggregationOptions} classes={{ toggle: "aggregation-toggle" }} />}
      {!hideGraph && <CompareChart
        tooltipFormatter={numberFormatter}
        metricSelector={<CompareSelect
          options={metrics}
          selectedOption={selectedMetric}
          setSelected={setMetric}
          saveToStore={saveMetricToStore}
          storeName={selectedView}
        />}
        {...{
          status,
          tickFormat: numberFormatter,
          startDate,
          date: selectedDate,
          setDate,
          endDate,
          data,
          items,
          fixedItemNumber,
          tableDownloadData,
          fileName,
          selectedMetric,
          selectedView,
        }}
      />}
      <CompareTable
        className={classNames({ "single-date": hideGraph })}
        firstCategoryOpened
        {...{
          items: detailsItems,
          data: detailsData,
          columns: items,
          trackPanelTrigger,
          fixedItemNumber,
          factorCategories,
        }}
      />
    </div>
  </Paper>
}

CompareExposure.propTypes = {
  status: PropTypes.string.isRequired,
  data: DATA.isRequired,
  startDate: DATE.isRequired,
  endDate: DATE.isRequired,
  selectedDate: DATE,
  setDate: PropTypes.func.isRequired,
  metrics: METRICS.isRequired,
  selectedMetric: SELECTED_METRIC.isRequired,
  setMetric: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUmodeled: PropTypes.bool,
  })).isRequired,
  detailsItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.string,
    defaultOpen: PropTypes.bool,
    fn: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      fn: PropTypes.func.isRequired,
    })),
  })).isRequired,
  detailsData: PropTypes.array.isRequired,
  saveMetricToStore: PropTypes.func.isRequired,
  trackPanelTrigger: PropTypes.func.isRequired,
  fixedItemNumber: PropTypes.bool,
  hideGraph: PropTypes.bool,
  displayAggregationToggle: PropTypes.bool,
  setAggregationFn: PropTypes.func,
  aggregation: AGGREGATION_SHAPE,
  aggregationOptions: PropTypes.arrayOf(OPTION_SHAPE),
  contentSetId: PropTypes.string,
  factorCategories: FACTOR_CATEGORIES_SHAPE,
  fileName: DOWNLOAD_FILENAME,
  tableDownloadData: TABLE_DOWNLOAD_DATA,
}
